import React from 'react'
import { ZinButton } from '@tnl/zin-react'
import { SIGNIN_LABELS } from '@constants'
import { useAuthLabelsContext } from '@account/contexts/AuthLabelsContext'
import { SIGNIN_STEP_TO_BACKEND } from '@account/services/authLabels'
import type { SignInStepProps } from '../../types'

export interface UsernameRecoveredStepProps extends SignInStepProps {
  recoveredUsername: string
  onSignInWithUsername: (username: string) => void
}

export const UsernameRecoveredStep: React.FC<UsernameRecoveredStepProps> = ({ recoveredUsername, onSignInWithUsername, isLoading = false }) => {
  const { getLabel } = useAuthLabelsContext()
  const backendStep = SIGNIN_STEP_TO_BACKEND['forgot-username-confirmation'] ?? 'usernameRecovered'

  const handleSignInWithUsername = () => {
    onSignInWithUsername(recoveredUsername)
  }

  const bodyText = getLabel('signIn', backendStep, 'description', SIGNIN_LABELS.WELCOME_BACK_USERNAME_OPTION2)
  const signInWithUsernameText = getLabel('signIn', backendStep, 'submitButton', SIGNIN_LABELS.SIGN_IN_WITH_USERNAME)

  return (
    <div className="w-full space-y-6">
      {/* Body text */}
      <div className="text-center">
        <p className="text-core-text-secondary text-base leading-relaxed max-w-md mx-auto">{bodyText || SIGNIN_LABELS.WELCOME_BACK_USERNAME_OPTION2}</p>
      </div>

      {/* Username display */}
      <div className="text-center">
        <span className="subtitle-3">{recoveredUsername}</span>
      </div>

      {/* Action button */}
      <ZinButton
        onClick={handleSignInWithUsername}
        loading={isLoading}
        variant="primary"
        full>
        {signInWithUsernameText || SIGNIN_LABELS.SIGN_IN_WITH_USERNAME}
      </ZinButton>
    </div>
  )
}

export default UsernameRecoveredStep
